module.exports = __webpack_public_path__ + "media/customizations/ranchlife/logo-new-9082c66089868bb6bb0cc6d483ee474c.png";